// extracted by mini-css-extract-plugin
module.exports = {"error-container":"ErrorFallback_error-container__2G6zQ","result":"ErrorFallback_result__2gNh8","homeBtn":"ErrorFallback_homeBtn__1ecu4"};